import React, {useState, useEffect} from "react";

import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid, Typography, Dialog, DialogTitle, DialogActions, DialogContent} from "@mui/material";
import * as PropTypes from "prop-types";
import {CompCheckbox} from "../../../../../components/Checkbox";
import { CompPartitionHeader } from "../../../../../components/PartitionHeader";
import { CompDatePickerNew } from "../../../../../components/newComponents/DatePickerNew";
import { CompTimePickerNew } from "../../../../../components/newComponents/TimePickerNew";
import {connect} from "react-redux";
import DeleteIcon from '@mui/icons-material/Delete';
import {CompRadioGroup} from "../../../../../components/RadioGroup";
import {
    getFeedbackReport,
    deleteFeedback,
    listFeedback,
    recreateLinksForFunction,
} from "../../../function.actions";
import { handleDateTimeChange } from "../../../components/functionFormComponentUtils";
import { formatISODateStr } from "../../../../../utils";
import {useTranslation} from "react-i18next";
import {ageOptions, genderOptions} from "../../../../feedback/feedbackOptions";
import CustomSnackbar from "../../../../../components/CustomSnackbar";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import { ButtonPrimary } from "../../../../../components/newComponents/ButtonPrimary";

const FeedbackComponent = (props) => {
    const {
        handleChange,
        editorActivated,
        selectedFunction,
        functionId,
        fieldErrors = {},
        action,
        handleMultiselectChange,
        func
    } = props;

    const {t} = useTranslation('translation');
    const disableAll = !editorActivated || action === "share";

    const [languageOption, setLanguageOption] = useState("fi");
    const [feedbackOption, setFeedbackOption] = useState("1");

    const [fetchFeedack, setFetchFeedback] = useState(true);
    const [listDone, setListDone] = useState(false);
    const [feedbackDone, setFeedbackDone] = useState(false);
    const [open, setOpen] = useState(false);
    const [feedbackCodeOpen, setFeedbackCodeOpen] = useState(false)
    const [localFeedbackList, setLocalFeedbackList] = useState([])
    
    //NOTE: consider refactoring dialog to controlled component, no time this moment to do so
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        if (listDone && feedbackDone) {
            setFeedbackDone(false);
            setListDone(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listDone, feedbackDone])

    //had to put local feedbacklist here due to some weird data loss when using selectedfunction
    useEffect(() => {
        if (selectedFunction?.feedbackList?.length > 0) {
            setLocalFeedbackList([...selectedFunction.feedbackList]);
        } else {
            setLocalFeedbackList([]);
        }
    }, [selectedFunction]);

    useEffect(() => {
        if (!fetchFeedack) return;

        func.feedbackReport = null;
        if(parseInt(functionId) === selectedFunction.id) {
            handleFeedbackFetch();
            handleListFeedback();
            setFetchFeedback(false);
        }
    }, [fetchFeedack]);

    const getCode = (link = false) => {
        if (selectedFunction.id && func["linkupdate"+selectedFunction.id]) {
            const code = func["linkupdate"+selectedFunction.id];
            if (selectedFunction.feedbackCode !== code) {
                selectedFunction.feedbackCode = code;
            }
        }
        var loc = window.location.href+"/";
        loc.replace("function", "feedback");
        return link ? loc + selectedFunction.feedbackCode: selectedFunction.feedbackCode;
    }

    const getQRLink = () => {
        return "/feedback/"+getCode()+"-"+languageOption+"-"+feedbackOption+"-preview";
    }

    const getLink = () => {
        return "/feedback/"+getCode();
    }

    const handleQRcodeLinkCopy = () => {
        var new_link = getLink().replace(/-preview/g, '');
        navigator.clipboard.writeText(new URL(window.location.origin + new_link))
        setOpen(true)
    }

    const handleDeleteFeedback = async (row) => {
        try {
            await props.deleteFeedback(row)
            props.listFeedback(selectedFunction.id)
        } catch (error) {
            console.error('Error deleting feedback:', error)
        }
    };

    const handleListFeedback = async () => {
        if (selectedFunction.id) {
                props.listFeedback(selectedFunction.id)
        }
        setListDone(true);
    }

    const handleFeedbackFetch = async () => {
        if (selectedFunction.id) {
            await new Promise((resolve) =>
                props.getFeedbackReport(selectedFunction.id, resolve)
            );
        }
        setFeedbackDone(true);
    }

    const feedbackChoices = [
        {
            label: t('function.gender_and_age'),
            key: "feedbackGenderAndAge",
            value: selectedFunction.feedbackGenderAndAge
        },
        {
            label: t('function.function_rating'),
            key: "feedbackFunctionRating",
            value: selectedFunction.feedbackFunctionRating
        },
        {
            label: t('function.function_comment'),
            key: "feedbackFunctionComment",
            value: selectedFunction.feedbackFunctionComment
        },
        {
            label: t('function.showInLocationCode'),
            key: "showInLocationCode",
            value: selectedFunction.showInLocationCode
        }
    ];


    const languageOptions = [
        {
            label: t('common.fi'),
            value: "fi"
        },
        {
            label: t('common.sv'),
            value: "sv"
        }
    ];

    const feedbackOptions = [
        {
            label: t('function.signAndfeedback'),
            value: "1"
        },
        {
            label: t('function.onlyFeedback'),
            value: "2"
        },
        {
            label: t('function.onlySignIn'),
            value: "3"
        }
    ];

    const generateLinks = (event, id) => {
        event.preventDefault();
        setFeedbackCodeOpen(true)
        props.recreateLinksForFunction(id);
    }

    const handleAlertClose = () => {
        setFeedbackCodeOpen(false)
        setOpen(false);
    };


    const feedbackLinksView = (
        <Grid container size={{xs: 12,sm: 4}} sx={{width: '100% !important'}}>
            <Grid className="function_feedback_dates-comp" container spacing={2} sx={{paddingLeft: "0 !important", /* marginTop: '5vh', */ width:"100%", justifyContent: "space-between"}}>
                <Grid item size={{xs: 12, sm: 6}} sx={{width: "45%"}}>
                    <CompCheckbox
                        booleanmode={true}
                        rows={feedbackChoices}
                        selected={selectedFunction}
                        disabled={disableAll}
                        onChange={handleMultiselectChange}
                        name={"feedbackChoices"}
                    />
                </Grid>
                <Grid item size={{xs: 12, sm: 6}} sx={{width: "50%", alignContent: "flex-end"}}>
                    <Grid size={{xs: 12, sm: 3}} sx={{display: "flex", flexDirection: "row", width: "100% !important", gap: "20px"}}>
                        <CompDatePickerNew
                            label={`${t('function.start_date_feedback')}`}
                            value={formatISODateStr(selectedFunction.startDatetimeFeedback)}
                            disabled={disableAll}
                            name="startDateFeedback"
                            isLabelShrink={true}
                            error={fieldErrors.startDatetimeFeedback}
                            onChange={e => handleDateTimeChange(e, 'startDateFeedback', selectedFunction, handleChange)}
                        />
                        <CompDatePickerNew
                            label={`${t('function.end_date_feedback')}`}
                            value={formatISODateStr(selectedFunction.endDatetimeFeedback)}
                            isLabelShrink={true}
                            disabled={disableAll}
                            name="endDateFeedback"
                            error={fieldErrors.endDatetimeFeedback}
                            onChange={e => handleDateTimeChange(e, 'endDateFeedback', selectedFunction, handleChange)}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 3}} sx={{display: "flex", flexDirection: "row", width: "100% !important", gap: "20px"}}>
                        <CompTimePickerNew
                            label={`${t('function.start_time_feedback')}`}
                            value={selectedFunction.startDatetimeFeedback}
                            isLabelShrink={true}
                            disabled={disableAll}
                            name="startTimeFeedback"
                            error={fieldErrors.startDatetimeFeedback}
                            onChange={e => handleDateTimeChange(e, 'startTimeFeedback', selectedFunction, handleChange)}
                        />
                        <CompTimePickerNew
                            label={`${t('function.end_time_feedback')}`}
                            value={selectedFunction.endDatetimeFeedback}
                            isLabelShrink={true}
                            disabled={disableAll}
                            name="endTimeFeedback"
                            error={fieldErrors.endDatetimeFeedback}
                            onChange={e => handleDateTimeChange(e, 'endTimeFeedback', selectedFunction, handleChange)}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    const feedbackQRCodeView = (
        <Grid size={{ xs: 12, sm: 8 }}>
            <Grid container spacing={2}>
                <Grid item size={{xs: 12, sm: 12}} sx={{display: 'flex', gap: '2vh'}}>
                    <CompTextFieldNew
                        label={t('function.feedback_code')}
                        isLabelShrink={true}
                        value={getCode()}
                        disabled={true}
                        name="feedbackLink"
                    />
                    <ButtonPrimary
                        key={'generate_new_code'}
                        className="generate-new-link-btn"
                        onClick={e => generateLinks(e, selectedFunction.id)}
                        disabled={!editorActivated}>
                        {/* Think about refreshicon usage to keep ui simple(ish) */}
                        {/* <RefreshIcon /> */}{t('function.generate_links')}
                    </ButtonPrimary>
                    <CustomSnackbar open={feedbackCodeOpen} onClose={handleAlertClose} severity="success" message={t('function.new_code_created')} />
                </Grid>
                <Grid>
                    <Grid gap={1} sx={{marginBottom: "10%", display: 'flex', flexDirection: 'column', width: '100% !important'}} size={{xs: 12, sm: 2}}>
                        <ButtonPrimary className='qr_code-btn' onClick={handleQRcodeLinkCopy} sx={{cursor: 'pointer', whiteSpace: "nowrap"}}>
                            {t('function.link_to_function')}
                        </ButtonPrimary>
                        <ButtonPrimary className='qr_code-btn' onClick={setDialogOpen} sx={{cursor: 'pointer', whiteSpace: "nowrap"}}>
                            {t('function.feedbackOption')}
                        </ButtonPrimary>
                        <CustomSnackbar open={open} onClose={handleAlertClose} severity="success" message={t('common.link_copied')} />
                    </Grid>
                    <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                        <DialogTitle>{t('function.QR_code')}</DialogTitle> {/* TODO translations */}
                            <DialogContent dividers>
                                <Grid container>
                                    <Grid size={{xs: 12, sm: 4}}>
                                        <div className={'label'}>{t('function.languageOption')}</div>
                                        <CompRadioGroup
                                            name="languageOption"
                                            selected={languageOption}
                                            rows={languageOptions}
                                            onChange={(e) => setLanguageOption(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid size={{xs: 12, sm: 4}}>
                                        <div className={'label'}>{t('function.feedbackOption')}</div>
                                        <CompRadioGroup
                                            name="feedbackOption"
                                            selected={feedbackOption}
                                            rows={feedbackOptions}
                                            onChange={(e) => setFeedbackOption(e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        <DialogActions>
                            <Grid size={{xs: 12, sm: 4}}>
                                <ButtonPrimary className='qr_code-btn' onClick={() => window.open(getQRLink())} sx={{cursor: 'pointer', whiteSpace: "nowrap"}}>
                                    {t('function.feedback_link')}
                                </ButtonPrimary>
                                <ButtonPrimary type="button" onClick={() => setDialogOpen(false)}>Peruuta</ButtonPrimary>
                            </Grid>
                        </DialogActions>
                    </Dialog>
                </Grid>
            </Grid>
        </Grid>
    );

    const feedbackItems = selectedFunction.feedbackList?.length > 0 ? selectedFunction.feedbackList : localFeedbackList || [];
    const signupItems = feedbackItems.filter(item => item.age !== null && item.gender !== null);
    const commentItems = feedbackItems.filter(item => item.comment !== null || item.rating !== null);

    return (
        <>
                <Grid className={'MuiGrid-item function_feedback_signup-comp'} xs={12}>
                    <CompPartitionHeader text={t('function.youth_participation_and_feedback')}/>
                        <Typography className={'modalDescription participants_feedback_desc'}>
                            {t("function.participants_and_feedback_description")}
                        </Typography>

                <Grid container spacing={6} xs={12} sx={{ marginTop: '2vh', display: 'flex', width: '100%', marginBottom: '2vh', flexDirection: "column" }}>
                    {selectedFunction.id && editorActivated}
                    {/* selectedFunction.id &&  */feedbackLinksView}
                    {selectedFunction.id && selectedFunction.feedbackCode && feedbackQRCodeView}
                </Grid>
                    
                {/* something wrong with mui flexbox and tables. Forcing 50% width to tables to generate desired ui */}
            {selectedFunction.id && (
                    <Grid className="feedback_signup-wrapper" container sx={{paddingLeft: '0px !important'}}>
                        <Grid item xs={12} md={6} sx={{ width: "50%" }} className="feedback_participants">
                            <TableContainer>
                                <Typography fontWeight={600} variant="h7" className="modalDescription">
                                    {t('function.function_participants')}
                                </Typography>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="table-header">{t('feedback.date')}</TableCell>
                                            <TableCell className="table-header">{t('feedback.age')}</TableCell>
                                            <TableCell className="table-header">{t('feedback.gender')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {signupItems.map((row, index) => (
                                        <TableRow hover key={`row-${index}`}>
                                            <TableCell>{formatISODateStr(row.date)}</TableCell>
                                                <TableCell>
                                                    {row.age !== null
                                                    ? t(ageOptions.find(obj => obj.value === row.age.toString())?.label || '')
                                                    : ''}
                                                </TableCell>
                                                <TableCell>
                                                    {row.gender !== null
                                                    ? t(genderOptions.find(obj => obj.value === row.gender.toString())?.label || '')
                                                    : ''}
                                                </TableCell>
                                            <TableCell>
                                                {action === "edit" ? (<ButtonPrimary onClick={() => handleDeleteFeedback(row.id)}>
                                                    {/* {t('function.delete_participant')} */}<DeleteIcon />
                                                </ButtonPrimary>) : (<></>)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        <Grid item xs={12} md={6} sx={{ width: "50%" }} className="feedback_rating">
                            <TableContainer>
                                <Typography fontWeight={600} variant="h7" className="modalDescription">
                                    {t('common.feedback')}
                                </Typography>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="table-header">{t('feedback.date')}</TableCell>
                                            <TableCell className="table-header">{t('feedback.rating')}</TableCell>
                                            <TableCell className="table-header">{t('feedback.comment')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {commentItems.map((row, index) => (
                                        <TableRow hover key={`row2-${index}`}>
                                            <TableCell>{formatISODateStr(row.date)}</TableCell>
                                                <TableCell>
                                                    {row.rating
                                                    ? row.rating === -1
                                                        ? t('feedback.not_answered')
                                                        : row.rating
                                                    : ''}
                                                </TableCell>
                                            <TableCell>{row.comment}</TableCell>
                                        <TableCell>
                                            {action === "edit" ? (<ButtonPrimary onClick={() => handleDeleteFeedback(row.id)}>
                                                {/* {t('function.delete')} */}<DeleteIcon />
                                            </ButtonPrimary>) : (<></>)}
                                        </TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>)}
                </Grid>
            </>
    );
}

FeedbackComponent.propTypes = {
    label: PropTypes.string,
    editorActivated: PropTypes.bool,
    shared: PropTypes.bool,
    onChange: PropTypes.func,
    selectedFunction: PropTypes.object,
    selectedLocation: PropTypes.object,
    fieldErrors: PropTypes.object,
    actionButtons: PropTypes.array,
    functionTemplateButtons: PropTypes.array,
    allPartitionsOpen: PropTypes.bool,
    updateData: PropTypes.bool,
    youthData: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        func: state.func,
        selectedFunction: state.func.selectedFunction,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getFeedbackReport: (eventId) => dispatch(getFeedbackReport(eventId)),
        deleteFeedback: (feedbackItemId) => dispatch(deleteFeedback(feedbackItemId)),
        listFeedback: (eventId) => dispatch(listFeedback(eventId)),
        recreateLinksForFunction: (id, onSuccess, onFailure) => dispatch(recreateLinksForFunction(id, onSuccess, onFailure)),
    };
}

export const FunctionFeedbackComp = connect(mapStateToProps, mapDispatchToProps)(FeedbackComponent);
